import { HttpStatusCodeEnum } from '../../@shared/domain/enums/HttpStatusCode.enum'
import { ExclusionZone } from '../domain/entities/ExclusionZone'
import { IExclusionZoneRepository } from '../domain/repos/IExclusionZone.repository'
import { ExclusionZoneClient } from './ports/ExclusionZoneClient.abstract'
import { CreateExclusionZoneSchema } from './schemas/CreateExclusionZone.schema'
import { ExclusionZoneSchema } from './schemas/ExclusionZone.schema'
import { UpdateExclusionZoneSchema } from './schemas/UpdateExclusionZone.schema'

export class ExclusionZoneRepositoryApiAdapter implements IExclusionZoneRepository {
	private _endpoint = '/v1/zona-de-exclusao'

	constructor(private _httpClient: ExclusionZoneClient) {}
	async delete(exclusionZoneIds: string[]): Promise<void> {
		const response = await this._httpClient.delete(this._endpoint, {
			params: { id: exclusionZoneIds },
			paramsSerializer: {
				indexes: null,
			},
		})

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível excluir zona de exclusão. Por favor, tente novamente')
		}

		return
	}
	async getAll(customerId: string): Promise<ExclusionZone[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-vinculados-a-id-customer/${customerId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			return []
		}

		return response.data.map((data: any) => ExclusionZoneSchema.parse(data))
	}

	async create(exclusionZone: ExclusionZone): Promise<void> {
		const input = CreateExclusionZoneSchema.parse(exclusionZone)

		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		}

		const response = await this._httpClient.post(this._endpoint, JSON.stringify(input), config)

		if (response.status !== HttpStatusCodeEnum.Created) {
			throw new Error('Não foi possível cadastrar zona de exclusão. Por favor, tente novamente')
		}

		return
	}

	async update(exclusionZone: ExclusionZone): Promise<void> {
		const input = UpdateExclusionZoneSchema.parse(exclusionZone)

		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		}

		const response = await this._httpClient.put(this._endpoint, JSON.stringify(input), config)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível editar zona de exclusão. Por favor, tente novamente')
		}

		return
	}
}
